import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
  trackEvent?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  trackEvent
}: ButtonProps) {
  const sharedClassName = `inline-block bg-gold hover:bg-gold-light text-navy font-semibold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 tracking-wide uppercase text-sm md:text-base w-full md:w-auto text-center ${className}`;
  const handleClick = (e?: React.MouseEvent) => {
    if (trackEvent && typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', trackEvent);
    }
    if (onClick) onClick();
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClassName} onClick={handleClick} data-id="element-148">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClassName} onClick={handleClick} data-id="element-149">
      {children}
    </motion.button>;
}